import React from "react";
import {
  Link,
  Outlet,
  useLocation,
} from "react-router-dom";
import { accountSettingsRoutes } from "../../constants/routes";
import { hasAccessCheck } from "../../utils/hasAccessCheck";
import CommonHeader from "../../components/common-header";


// Define the main component
const AccountSettings: React.FC = () => {

  const location = useLocation(); //

  return (
    <>
<div className="mt-4">
<CommonHeader
     heading="Account settings"
     description="Manage account settings and preferences securely"
     customClass="card bg-[#025963] p-[12px] rounded-[8px]"
  
/>
</div>


    <div className="flex h-screen bg-white">
      {/* Left Menu - 30% */}
      <div className="w-1/5 ">
        {/* <div className="p-6">
          <h2 className="text-xl font-semibold text-gray-800  ">
            Account Settings
          </h2>
        </div>
        <hr className="border-t border-gray-300" /> */}
        <nav className="text-[#778399] font-medium rounded-lg  border border-gray-200 mt-4 mr-4">
        <div className="px-2 mb-2">
          <p className="font-medium text-xs p-2 mt-2">CONFIGURATIONS</p>
         
          {accountSettingsRoutes.map((route, index) => {
            if (route.protected && !hasAccessCheck(route?.requiredAccess ? route?.requiredAccess : "")) {
              return null; // Skip link if user doesn't have required access
            }

            const isActive = location.pathname === `/account-settings/${route.path}`;
            

            return (
              <div key={index} className={`flex items-center rounded-lg px-2 mb-1 font-normal transition duration-200 
                ${isActive ? "bg-[#EDF8F9] text-[#2C6E75] font-medium" : "hover:bg-[#EDF8F9] hover:text-[#2C6E75] hover:font-medium"}`}>

              
                {route.icon && <route.icon className="w-6 h-6 hover:text-[#2C6E75]" />}
                
              <Link
                key={index}
                to={`/account-settings/${route.path}`}  
                className="block p-2 transition duration-200 rounded-lg "
              >
                
                <span className={`${isActive ? "bg-[#EDF8F9] text-[#2C6E75] font-medium" : ""}`}>{route.Name}</span>
              </Link>
              </div>
            );
          })}

          </div>
        </nav>
      </div>
      {/* Right Content - 70% */}
      <div className="w-4/5  mt-4  bg-white ">
        <Outlet />
      </div>
    </div>
    </>
  );
};


export default AccountSettings;
